import { useState, useEffect } from "react";

const STORAGE_KEY = "mood_analytics_consent";

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      setVisible(true);
    } else if (saved === "granted") {
      window.gtag("consent", "update", { analytics_storage: "granted" });
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "granted");
    window.gtag("consent", "update", { analytics_storage: "granted" });
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(STORAGE_KEY, "denied");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#f7bfd8] text-[#F36D26] p-4 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left">
          Nous utilisons les cookies pour mesurer l'audience du site.{" "}
          <a href="/cgv" className="underline hover:text-orange-800">
            En savoir plus
          </a>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleRefuse}
            className="px-4 py-2 border border-[#F36D26] rounded-lg text-sm hover:bg-orange-100 transition"
          >
            Refuser
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 bg-[#F36D26] text-white rounded-lg text-sm hover:bg-orange-700 transition"
          >
            Accepter les cookies
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
